// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";

function pmAuthNameToTypeMapper(authConnectorName) {
  if (authConnectorName === "plaid") {
    return "PLAID";
  } else {
    return "NONE";
  }
}

function pmAuthConnectorToScriptUrlMapper(authConnector) {
  if (authConnector === "PLAID") {
    return "https://cdn.plaid.com/link/v2/stable/link-initialize.js";
  } else {
    return "";
  }
}

function mountAuthConnectorScript(authConnector, onScriptLoaded, logger) {
  var authConnector$1 = Core__Option.getOr(authConnector, "");
  var pmAuthConnectorScriptUrl = pmAuthConnectorToScriptUrlMapper(pmAuthNameToTypeMapper(authConnector$1));
  var pmAuthConnectorScript = document.createElement("script");
  logger.setLogInfo("Pm Auth Connector " + authConnector$1 + " Script Loading", "PM_AUTH_CONNECTOR_SCRIPT", undefined, undefined, undefined, undefined, undefined);
  pmAuthConnectorScript.src = pmAuthConnectorScriptUrl;
  pmAuthConnectorScript.onerror = (function (param) {
      logger.setLogInfo("Pm Auth Connector " + authConnector$1 + " Script Load Failure", "PM_AUTH_CONNECTOR_SCRIPT", undefined, undefined, undefined, undefined, undefined);
    });
  pmAuthConnectorScript.onload = (function () {
      onScriptLoaded(authConnector$1);
      logger.setLogInfo("Pm Auth Connector " + authConnector$1 + " Script Loaded", "PM_AUTH_CONNECTOR_SCRIPT", undefined, undefined, undefined, undefined, undefined);
    });
  document.body.appendChild(pmAuthConnectorScript);
}

function mountAllRequriedAuthConnectorScripts(pmAuthConnectorsArr, onScriptLoaded, logger) {
  pmAuthConnectorsArr.forEach(function (item) {
        mountAuthConnectorScript(item, onScriptLoaded, logger);
      });
}

function findPmAuthAllPMAuthConnectors(paymentMethodListValue) {
  var bankDebitPaymentMethodsArr = paymentMethodListValue.filter(function (item) {
        return item.payment_method === "bank_debit";
      });
  var pmAuthConnectorDict = {};
  bankDebitPaymentMethodsArr.forEach(function (item) {
        item.payment_method_types.forEach(function (item) {
              if (Core__Option.isSome(item.pm_auth_connector)) {
                pmAuthConnectorDict[item.payment_method_type] = item.pm_auth_connector;
                return ;
              }
              
            });
      });
  return pmAuthConnectorDict;
}

function getAllRequiredPmAuthConnectors(pmAuthConnectorsDict) {
  var requiredPmAuthConnectorsArr = Object.values(pmAuthConnectorsDict);
  return requiredPmAuthConnectorsArr.filter(function (item, idx) {
              return idx === requiredPmAuthConnectorsArr.indexOf(item);
            });
}

export {
  pmAuthNameToTypeMapper ,
  pmAuthConnectorToScriptUrlMapper ,
  mountAuthConnectorScript ,
  mountAllRequriedAuthConnectorScripts ,
  findPmAuthAllPMAuthConnectors ,
  getAllRequiredPmAuthConnectors ,
}
/* No side effect */
